export const lazyCall = requestAnimationFrame;
